import { addMinutes, differenceInMilliseconds } from "date-fns";

import type { Session } from "@/features/coaching/models";

const MAX_REFETCH_INTERVAL = 3600000; // 1 hour

export const getSessionsRefetchInterval = (
  data?: Pick<Session, "startAt" | "duration">[],
) => {
  const firstSession = data?.[0];

  if (!firstSession) {
    return false;
  }

  const { startAt, duration } = firstSession;
  const endAt = addMinutes(startAt, duration + 1);

  return Math.min(
    MAX_REFETCH_INTERVAL,
    differenceInMilliseconds(endAt, new Date()),
  );
};
